import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {LinearProgress, TablePagination} from "@mui/material";
import {useSitStores} from "~/stores";
import {TARGET_COLUMNS} from "./columns";
import {MithraTablePaginationActions} from "~/components/table-pagination/MithraTablePaginationActions.tsx";
import {TargetFilters} from "./targetFilters";
import {generatePath, useNavigate} from "react-router";
import {sitRoutes} from "../../routing/sitRoutes";
import {CurrencyComponent} from "~/components/currency-component/CurrencyComponent.tsx";
import {CategorizationViewOnlyComponent} from "~/components/categorization/CategorizationViewOnlyComponent.tsx";
import moment from "moment/moment";

const RIGHT_COLS = ['saving_amount'];

export const TargetTable: React.FC = observer(() => {
    const {targetListStore: store, ccStore} = useSitStores();
    const navigate = useNavigate();

    useEffect(() => {
        store.reloadData(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const result = store.targetListRM.result;
    const ordering = store.ordering;
    const sortOn = (field?: string) => {
        if (field) store.setOrdering(ordering === field ? '-' + field : field);
    };
    const caret = (field?: string) => ordering === field ? ' ▲' : ordering === '-' + field ? ' ▼' : '';

    return (
        <div className="target-table-component sit-list">
            <TargetFilters/>

            {store.targetListRM.busy && <LinearProgress variant="indeterminate"/>}

            <div className="sit-table-wrap">
                <table className="sit-table">
                    <thead>
                        <tr>
                            {TARGET_COLUMNS.map((c, i) => (
                                <th key={i}
                                    className={(RIGHT_COLS.includes(c.columnFieldId ?? '') ? 'right ' : '')
                                    + (c.columnFieldId ? 'sortable' : '')
                                    + (ordering.replace('-', '') === c.columnFieldId ? ' sorted' : '')}
                                    style={{minWidth: c.minWidth}}
                                    onClick={() => sortOn(c.columnFieldId)}>
                                    {c.txt}<span className="sit-sort-caret">{caret(c.columnFieldId)}</span>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    {result && <tbody>
                        {result.results.map((row) => (
                            <tr key={row.id} style={{cursor: 'pointer'}}
                                onClick={() => navigate(generatePath(sitRoutes.sit_target, {targetId: row.id}))}>
                                <td>
                                    <div className="sit-row-title">{row.title}</div>
                                </td>
                                <td>{row.owner ? row.owner.name : 'No owner'}</td>
                                <td>
                                    {ccStore.showFullCategory
                                        ? <div className="sit-cell-categories">
                                            {[...new Set(row.categories)].map(id =>
                                                <CategorizationViewOnlyComponent key={id}
                                                                                 category={ccStore.getCategoryLabels(id)}/>)}
                                        </div>
                                        : row.categories.map(id => ccStore.getCategoryL1(id))
                                            .filter((v, i, a) => a.indexOf(v) === i).join(', ')}
                                </td>
                                <td>{row.companies.map(id => ccStore.getCompanyTitle(id)).join(', ')}</td>
                                <td>{row.start_date ? moment(row.start_date).format('L') : ''}</td>
                                <td>{row.target_year}</td>
                                <td className="right"><CurrencyComponent v={row.saving_amount} nDigits={3}/></td>
                            </tr>
                        ))}
                    </tbody>}
                </table>
            </div>

            <TablePagination
                component="div"
                count={result?.count ?? 0}
                rowsPerPage={store.per_page}
                page={store.page}
                onPageChange={(_event, page: number) => store.setPage(page)}
                onRowsPerPageChange={(event) => store.setPerPage(parseInt(event.target.value) || 0)}
                ActionsComponent={MithraTablePaginationActions}
            />
        </div>
    );
});
